import "./LoadingPage.css";

import React from "react";

import CircularProgress from "@mui/material/CircularProgress";

export const LoadingPage = () => {
  return (
    <div className="loading-page-container">
      <CircularProgress size="20rem" sx={{ color: "rgb(2, 85, 31)" }} />
    </div>
  );
};
